import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { TranslatePipe } from '@ngx-translate/core';
import { EXTERNAL_LINKS } from '@libs/utils';

@Component({
  selector: 'lib-ffd-notes-invite-success',
  imports: [SvgIconComponent, TranslatePipe],
  templateUrl: './ffd-notes-invite-success.component.html',
  styleUrl: './ffd-notes-invite-success.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FfdNotesInviteSuccessComponent {
  protected readonly iosAppUrl = EXTERNAL_LINKS.FFD_NOTES_IOS_APP;
}
